<template>
  <div>
    <el-tabs tab-position="left" v-model="activeName" type="card" class="tabs-two">
      <el-tab-pane name="1" class="active">
        <span slot="label"><i class="el-icon"></i>智能诊断</span>
        <intelligentDiagnosis></intelligentDiagnosis>
      </el-tab-pane>
      <el-tab-pane name="2">
        <span slot="label"><i class="el-icon"></i>专家诊断</span>
        <expertDiagnosis></expertDiagnosis>
      </el-tab-pane>
    </el-tabs>
  </div>

</template>

<script>
import expertDiagnosis from "./expertDiagnosis";
import intelligentDiagnosis from "./intelligentDiagnosis";
export default {
  components: {
    expertDiagnosis,
    intelligentDiagnosis,
  },
  data () {
    return {
      activeName: '1'

    }
  },
  created () {
    this.activeName = this.$route.params.active ? this.$route.params.active : '1'
  },
}
</script>

<style lang="less" scoped>
</style>

